// src/utils/logger.ts

/**
 * 彩色日志输出工具
 * @param args 需要打印的参数
 */
export const $log = (...args: any[]) => {
  const style = [
    'color: #fff',
    'font-size: 14px',
    'font-weight: bold',
    'background: linear-gradient(90deg,rgb(137, 255, 107), #4ECDC4)',
    'padding: 4px 8px',
    'border-radius: 4px',
    'text-shadow: 1px 1px 2px rgba(0,0,0,0.3)'
  ].join(';')

  try {
    const stack = new Error().stack?.split('\n') || []
    const callerInfo = stack[2]?.trim().replace(/^at\s/, '') || ''
    // console.log(stack, 'stack')
    // 增强类型推断的文件名提取
    const fileName =
      callerInfo.match(/\/src\/.*?\.vue/)?.[0] ||
      callerInfo.split(' ')[0].split('/').pop() ||
      'unknown'

    // 更安全的方法名提取
    const methodName =
      callerInfo.match(/VueComponent\.(\w+)/)?.[1] ||
      callerInfo.split(' ')[0].split('.').pop() ||
      'anonymous'

    // 日志头部（使用标题样式）
    const logHeader = `%cFile: ${fileName} → ${methodName}%c\n`
    // const logHeader = `%cFile : ${callerInfo} \nFunction: ${fileName} → ${methodName}  `
    const logContent = args.map((p) => (typeof p === 'object' ? JSON.parse(JSON.stringify(p)) : p))

    console.log(logHeader, style, '\n', ...logContent)
  } catch (e) {
    console.log('%c LOG ERROR ', style, '\n', ...args)
  }
}
